import { styled } from '@mui/material/styles';

export const HeaderWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
}));

export const Badge = styled('div')(({ theme }) => ({
  width: '24px',
  height: '24px',
  borderRadius: '100%',
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '-14px',
  right: '-12px',

  p: {
    height: '24px',
  },
}));
